import { Form, Input, Modal } from 'antd';
import React, { memo, useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userActions } from '../../../../actions/user.actions';
import usePassword from '../../../../hooks/usePassword';
import changePassword from '../../requests/changePassword';
import './ChangePasswordPopup.scss';

const ChangePasswordPopup = ({ onExit }) => {
  const dispatch = useDispatch();
  const credentialUsername = useSelector(
    (store) =>
      store.authentication?.user?.username ||
      store.authentication?.user?.login ||
      store.authentication?.user?.Login ||
      store.authentication?.userInfo?.Login ||
      store.authentication?.userInfo?.UserName ||
      ''
  );
  const [
    newPassword,
    setNewPassword,
    confirmPassword,
    setConfirmPassword,
    errors,
  ] = usePassword();
  const [prevPassword, setPrevPassword] = useState('');
  const disabledConfirmButton = useMemo(() => {
    if (
      errors ||
      !newPassword ||
      !confirmPassword ||
      confirmPassword !== newPassword
    ) {
      return true;
    }
  }, [errors, newPassword, confirmPassword]);
  const onOk = useCallback(async () => {
    const success = await changePassword({
      oldPassword: prevPassword,
      newPassword: newPassword,
      confirmPassword: confirmPassword,
    });
    if (success) {
      onExit();
      dispatch(userActions.logout());
    }
  }, [prevPassword, newPassword, confirmPassword, dispatch, onExit]);
  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      if (!disabledConfirmButton) {
        onOk();
      }
    },
    [disabledConfirmButton, onOk]
  );
  const onPasswordChange = useCallback(
    (e) => setNewPassword(e.target.value),
    []
  );
  const onPassword2Change = useCallback(
    (e) => setConfirmPassword(e.target.value),
    []
  );
  const onPrevPasswordChange = useCallback(
    (e) => setPrevPassword(e.target.value),
    []
  );
  return (
    <Modal
      visible={true}
      onCancel={onExit}
      title={'Изменение пароля'}
      okText="Сменить пароль"
      onOk={onOk}
      okButtonProps={{ disabled: disabledConfirmButton }}
    >
      <form
        autoComplete="on"
        onSubmit={onSubmit}
      >
        <input
          className="change-password-popup__username"
          type="text"
          name="username"
          autoComplete="username"
          defaultValue={credentialUsername}
          tabIndex={-1}
          aria-hidden="true"
        />
        <div className="row">
          <Form.Item
            label="Введите старый пароль"
            colon={false}
            className="formItem"
          >
            <Input.Password
              name="oldPassword"
              autoComplete="current-password"
              value={prevPassword}
              onChange={onPrevPasswordChange}
            />
          </Form.Item>
        </div>
        <div className="row">
          <div className="col">
            <Form.Item
              label="Придумайте новый пароль"
              colon={false}
              className="formItem"
              help={
                newPassword && confirmPassword && !errors && 'Пароли совпадают'
              }
            >
              <Input.Password
                name="newPassword"
                autoComplete="new-password"
                onChange={onPasswordChange}
                value={newPassword}
              />
            </Form.Item>
          </div>
          <div className="col">
            <Form.Item
              label="Повторите пароль"
              colon={false}
              className="formItem"
              help={
                newPassword && confirmPassword && !errors && 'Пароли совпадают'
              }
            >
              <Input.Password
                name="confirmPassword"
                autoComplete="new-password"
                onChange={onPassword2Change}
                value={confirmPassword}
              />
            </Form.Item>
          </div>
        </div>
        {errors ? (
          <div className="row password_errors_hint">{errors}</div>
        ) : (
          <span>
            Пароль должен быть не менее 8 символов без пробелов, содержать
            латинские буквы разных регистров, хотя бы одну цифру и специальный
            символ
          </span>
        )}
      </form>
    </Modal>
  );
};

export default memo(ChangePasswordPopup);
